export default {
  preview: {
    label: 'Vorschau',
    tooltip: 'Die Bestellseite in einem neuen Tab ansehen.',
  },
  buttons: {
    visit_online_store: 'Online Shop',
  },
  toasts: {
    failed_to_launch_orders_portal_app: 'Das Auftragsportal konnte nicht gestartet werden',
  },
};
